
const FaqsSection = () => {
  const faqs = [
    {
      question: "What is Bromentum?",
      answer: "Bromentum is a decentralized collective fueling the intersection of memes, culture, crypto, and AI. Powered by the $TOP1 token, the network coordinates meme-native builders, deployers, and digital creatives using tools governed by the community — not a company."
    },
    {
      question: "Is $TOP1 an investment?",
      answer: "$TOP1 is a community token designed for participation in Bromentum initiatives. It is not an investment, does not represent ownership, and carries no expectation of financial return. It's a coordination tool for builders, meme warriors, and degens."
    },
    {
      question: "How do I participate?",
      answer: "Start with BroRankBot initiation, connect your wallet, and join the decentralized brotherhood. Participation is for utility, culture, and meme-powered coordination — not financial gain."
    },
    {
      question: "What are MNFTs?",
      answer: "MNFTs are digital collectibles celebrating men in Web3. They're cultural artifacts with meme utility, not investments. Owning an MNFT does not confer revenue, access to funding, or financial privileges."
    },
    {
      question: "How does community coordination work?",
      answer: "Through token-gated access to tools, participation in meme deployments, governance proposals (non-financial), and transparent multisig-managed resource buckets. All coordination is decentralized and community-driven."
    },
    {
      question: "Who controls Bromentum?",
      answer: "No single entity controls Bromentum. All resource buckets are non-custodial, managed by community-chosen multisig signers, and governed transparently. There is no central team, no entity, and no equity."
    }
  ];

  return (
    <section id="faqs" className="py-16 bg-secondary">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Get answers to the most common questions about BroMentum and our ecosystem.
          </p>
        </div>
        
        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-background rounded-lg p-6 border border-border">
              <h3 className="text-xl font-semibold text-foreground mb-3">{faq.question}</h3>
              <p className="text-muted-foreground leading-relaxed">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqsSection;
